import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
// MUI
import { Box, MenuList, Stack } from "@mui/material";
// Icons
import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { ReactComponent as SystemSettingsIcon } from "@/assets/icons/header/settings/SystemSettingsIcon.svg";
// Constants
import actions from "@/Constants/actionsList";
// Types
import { RootState } from "@/redux/store";
// Components
import ImageUserProfilePicture from "@/Layouts/components/ImageUserProfilePicture";
import { RenderMenuOptions, TRenderOptionConfiguration } from "./RenderMenusOptions";
// Hooks
import { useWrapperLayer } from "@/Common/context/wrapperLayer/WrapperLayerContext";

interface IUserMenuProps {
	onLogoutAction?: () => void;
}

export default function UserMenu(props: Readonly<IUserMenuProps>) {
	const { isDisabled } = useWrapperLayer();
	const user = useSelector((state: RootState) => state.user.user);

	const options: TRenderOptionConfiguration[] = useMemo(
		() => [
			{
				title: "User Preferences",
				link: "/user-preferences",
				requiredActions: [actions.VIEW_USER_PREFERENCES],
				icon: <ManageAccountsIcon className="!text-[17px]" />,
			},
			{
				title: "Account Settings",
				link: "/account-settings",
				requiredActions: "*",
				icon: <SystemSettingsIcon />,
			},
			{
				title: "Sign Out",
				link: "",
				requiredActions: "*",
				icon: <LogoutTwoToneIcon className="!text-[17px]" />,
				onClick() {
					props.onLogoutAction?.();
				},
			},
		],
		[props]
	);

	if (!user || isDisabled) {
		return null;
	}

	return (
		<MenuList id="account-btn-menu" className="min-w-[210px] !py-0">
			<Stack direction="column" alignItems="center" className="mt-3 !px-4">
				<Box justifyContent="center">
					<Link to={"/user-profile"}>
						<ImageUserProfilePicture context={"single"} widthImgHolder={"80"} className="user-menu-logo" />
					</Link>
				</Box>
				<Box justifyContent="center" className="font-montserrat font-medium text-default mt-2">
					{user ? `${user.fullName}` : ""}
				</Box>
				<Box justifyContent="center" className="font-montserrat font-medium text-[14px] text-default pb-px">
					{user ? user.position ?? "Sales Associate" : ""}
				</Box>
				<Box justifyContent="center" className="font-montserrat font-medium text-[14px] text-default pb-[10px]">
					{user ? user.employeeId ?? "" : ""}
				</Box>
			</Stack>

			<Box className="bg-gray-background pb-[13px]">
				<RenderMenuOptions arrayOptions={options} />
			</Box>
		</MenuList>
	);
}
